<div class="chat-window">
  @if (composing()) {
    <!-- COMPOSE: pick participants -->
    <app-user-picker
      [users]="state.users()"
      [currentUserId]="state.currentUser()?.id ?? ''"
      (participantsConfirmed)="onParticipantsConfirmed($event)"
      (cancelled)="cancelCompose()" />
  } @else {
    <!-- HEADER -->
    <div class="chat-header">
      @if (state.activeThreadId()) {
        <button class="back-btn" (click)="backToList()" aria-label="Back">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="#fff">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
          </svg>
        </button>
        <span class="header-avatar">{{ activeThreadInitials }}</span>
        <span class="header-title">{{ headerTitle }}</span>
      } @else {
        <span class="header-title">Instant Messages</span>
        @if (state.totalUnread() > 0) {
          <span class="header-badge">{{ state.totalUnread() }}</span>
        }
        <span class="header-spacer"></span>
        <button class="compose-btn" (click)="openCompose()" aria-label="New message">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="#fff">
            <circle cx="12" cy="12" r="11" fill="#6abf69"/>
            <path d="M12 7v10M7 12h10" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/>
          </svg>
        </button>
      }
    </div>

    <!-- BODY -->
    <div class="chat-body">
      @if (!state.activeThreadId()) {
        <!-- Conversation list -->
        <app-conversation-list
          [threads]="state.threads()"
          [activeThreadId]="state.activeThreadId()"
          [currentUserId]="state.currentUser()?.id ?? ''"
          (threadSelected)="onThreadSelected($event)" />
      } @else {
        <!-- Message thread -->
        <app-message-list
          [messages]="state.messages()"
          [currentUserId]="state.currentUser()?.id ?? ''"
          [typingIndicators]="state.typingIndicators()" />
        <app-message-input
          (messageSent)="onMessageSent($event)"
          (typing)="onTyping()" />
      }
    </div>
  }
</div>
